import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Section } from 'app/library/section/models/section.model';
import { IModuleCompletionSection } from 'app/library/user-section/interfaces/module-completion-section.interface';
import { SectionStats } from 'app/library/user-section/models/user-section.model';

export interface IModuleCompletionStatus {
    name: string;
    translationLabel: string;
    primaryColor: string;
    secondaryColor: string;
}

@Component({
    selector: 'app-manage-completion-dialog',
    templateUrl: './manage-completion-dialog.component.html',
    styleUrls: ['./manage-completion-dialog.component.scss'],
})
export class ManageCompletionDialogComponent implements OnInit {
    @Input()
    userSectionStats: SectionStats[];

    @Output()
    saveSections = new EventEmitter<IModuleCompletionSection[]>();

    dataSource: SectionStats[];
    displayedColumns: string[] = ['section', 'completion'];
    tempSections: IModuleCompletionSection[] = [];

    moduleCompletionStatuses: IModuleCompletionStatus[] = [
        {
            name: 'completed',
            translationLabel: 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED',
            primaryColor: '#71B340',
            secondaryColor: '#68A53B',
        },
        {
            name: 'notCompleted',
            translationLabel: 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.NOT_COMPLETED',
            primaryColor: '#ADAFB3',
            secondaryColor: '#A8AAAE',
        },
    ];

    constructor(public dialogRef: MatDialogRef<ManageCompletionDialogComponent>) {}

    ngOnInit(): void {
        this.dataSource = this.userSectionStats.map((sectionStat) => {
            if (sectionStat.completed) {
                return Object.assign({}, sectionStat, {
                    moduleCompletionStatus: this.moduleCompletionStatuses[0],
                });
            } else {
                return Object.assign({}, sectionStat, {
                    moduleCompletionStatus: this.moduleCompletionStatuses[1],
                });
            }
        });
    }

    updateStatus(statusName: string, section: Section): void {
        let tempSection: IModuleCompletionSection = { id: parseInt(section.id), completed: statusName === 'completed' ? true : false };

        this.dataSource = this.dataSource.map((sectionStat) => {
            if (sectionStat.section.id === section.id) {
                if (statusName === 'completed') {
                    return Object.assign({}, sectionStat, {
                        moduleCompletionStatus: this.moduleCompletionStatuses[0],
                    });
                } else {
                    return Object.assign({}, sectionStat, {
                        moduleCompletionStatus: this.moduleCompletionStatuses[1],
                    });
                }
            } else {
                return sectionStat;
            }
        });

        this.tempSections.forEach((value, index) => {
            if (value.id === tempSection.id) {
                this.tempSections.splice(index, 1);
            }
        });

        this.tempSections.push(tempSection);
    }

    saveChanges(): void {
        this.saveSections.emit(this.tempSections);
        this.dialogRef.close();
    }
}
